import { Theme } from '@mui/material';

export default function Checkbox(theme: Theme) {
    return {
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true,
                backgroundColor: theme.palette.primary[500]
            },
            styleOverrides: {
                root: {
                    color: theme.palette.semantic.icon.subtle,
                    '& .MuiSvgIcon-root': { fontSize: 16 },
                    '&.Mui-checked': {
                        color: theme.palette.semantic.int.checkBox
                    },
                    '&.Mui-disabled': {
                        color: theme.palette.semantic.int.disabled2
                    }
                }
            }
        }
    };
}
